import { Chip, useTheme } from "@mui/material";
import { useAlertAccent } from "../../context/AlertVisualContext";
import { alertAccentSx } from "./alertVisualPreferences";

const AlertTypeBadge = ({ type, label, ...props }) => {
  const theme = useTheme();
  const accent = useAlertAccent(type)(theme.palette.mode);
  return <Chip size="small" {...props} label={label || type} sx={{ ...alertAccentSx(accent), ...props.sx }} />;
};
export default AlertTypeBadge;
